export function Radio({
  name,
  value,
  checked,
  onChange,
}: {
  name: string;
  value: string;
  checked?: boolean;
  onChange: (value: string) => void;
}) {
  return (
    <div>
      <input
        checked={!!checked}
        name={name}
        type="radio"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
